import { formatCurrency } from '../../../utils/inspectorFormatters'

export const fmtInt = (n: number): string =>
  n.toLocaleString('en-AU', { maximumFractionDigits: 0 })

export const fmtMoney = (n: number): string =>
  formatCurrency(n, { minimumFractionDigits: 0, maximumFractionDigits: 0 })

export const fmtQty = (n: number): string =>
  n.toLocaleString('en-AU', { minimumFractionDigits: 4, maximumFractionDigits: 4 })

export const fmtQtyShort = (n: number): string =>
  n.toLocaleString('en-AU', { maximumFractionDigits: 2 })
